import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddHDD = createAsyncThunk(
  "other/AddHDD",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/hdd-create/`, data)
    return response.data
  }
); 

export const UpdateHDD = createAsyncThunk(
  "other/UpdateHDD",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/hdd-update/${data.id}/`, data)
    return response.data
  }
);

export const GetHDDList = createAsyncThunk(
  "user/GetHDDList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/hdd-list/`)
    return data
  }
);

export const DeleteHDD = createAsyncThunk(
  "other/DeleteHDD",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/hdd-delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

